import useThemeBreakpoint from '~/modules/common/hooks/useThemeBreakpoint';

export const genericAllItem = {
  key: 'all',
  label: 'All'
};

const tabWidths = {
  xl: 24,
  lg: 20,
  md: 17,
  sm: 14,
  xs: 14
};

export const createTabWidthStyles = theme => ({
  flexBasis: theme.spacing(tabWidths.md),
  minWidth: theme.spacing(tabWidths.md),
  width: theme.spacing(tabWidths.md),
  height: theme.spacing(5),
  [theme.breakpoints.only('xl')]: {
    flexBasis: theme.spacing(tabWidths.xl),
    minWidth: theme.spacing(tabWidths.xl),
    width: theme.spacing(tabWidths.xl),
    height: theme.spacing(5)
  },
  [theme.breakpoints.only('lg')]: {
    flexBasis: theme.spacing(tabWidths.lg),
    minWidth: theme.spacing(tabWidths.lg),
    width: theme.spacing(tabWidths.lg),
    height: theme.spacing(5)
  },
  [theme.breakpoints.only('sm')]: {
    flexBasis: theme.spacing(tabWidths.sm),
    minWidth: theme.spacing(tabWidths.sm),
    width: theme.spacing(tabWidths.sm),
    height: theme.spacing(5)
  },
  [theme.breakpoints.only('xs')]: {
    flexBasis: theme.spacing(tabWidths.xs),
    minWidth: theme.spacing(tabWidths.xs),
    width: theme.spacing(tabWidths.xs),
    height: theme.spacing(5)
  }
});

export const useThemeWidth = theme => {
  const breakpoint = useThemeBreakpoint(theme);

  return tabWidths[breakpoint];
};
